import { Tooltip } from "antd";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { toolTipDescriptions } from "../helpers";

const DropDownMenu = ({
  label,
  value,
  name,
  options,
  onChange,
  placeholder = "",
  disabled = false,
  toolTip = false,
  required = false,
  onKeyDown,
}) => {
  return (
    <div className="h-fit">
      <div className="flex  items-center">
        <label className="pl-2">{label}</label>
        <span className="text-red-500 pl-1">{required && ` *`}</span>
        {toolTip && (
          <Tooltip title={toolTipDescriptions?.[toolTip] || "No description"}>
            <span className="text-lg text-blue-500 px-1 cursor-pointer">
              <IoMdInformationCircleOutline />
            </span>
          </Tooltip>
        )}
      </div>
      <select
        className={`w-full border ${
          disabled ? "bg-gray-200" : "bg-white"
        } border-gray-300 flex justify-between items-center p-2 rounded-md outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600 duration-500`}
        onChange={onChange}
        name={name}
        id={name}
        onKeyDown={onKeyDown}
        value={value}
        disabled={!options || options.length === 0 || disabled}
      >
        <option className="text-gray-500" value="" disabled>
          {placeholder || "Select"}
        </option>

        {options &&
          options.length > 0 &&
          options.map((item, index) => (
            <option value={item.value} key={index}>
              {item.label}
            </option>
          ))}
      </select>
    </div>
  );
};

export default DropDownMenu;
